<template>
<div class="c-menu" :class="{'c-menu--show': isShowNav}" :style="setMvHeight">
  <div class="c-menu__bg" @click="closeMenu"></div>
  <Transition name="c-menu">
    <div v-show="isShowNav" class="c-menu__wrap">
      <div class="scroller">
        <div class="logo">
          <a href="#" @click.prevent="anchor('p-lp')">
            <img src="/lp/assets/img/common/logo.png" alt="WITH EARTH GARDEN" width="174" height="122">
          </a>
        </div>

        <ul class="links">
          <li>
            <a href="#" @click.prevent="anchor('feature')">
              <span class="en">FEATURES</span>
              <span class="ja">お客様に選ばれる家づくり</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="anchor('reviews')">
              <span class="en">CUSTOMER REVIEWS</span>
              <span class="ja">住んでいるからわかること</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="anchor('reliability')">
              <span class="en">RELIABILITY</span>
              <span class="ja">品質と保証・サポート</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="anchor('trust')">
              <span class="en">TRUST AND RELIANCE</span>
              <span class="ja">信用と信頼</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="anchor('recommendations')">
              <span class="en">RECOMMENDATIONS</span>
              <span class="ja">おすすめの新着物件</span>
            </a>
          </li>
        </ul>

        <ul class="btns">
          <li>
            <a class="c-btn c-btn--recommend-m c-btn--shadow" href="#" @click.prevent="anchor('recommendations')"></a>
          </li>
          <li>
            <a class="c-btn c-btn--contact-m c-btn--shadow" href="#" @click.prevent="anchor('c-form')"></a>
          </li>
        </ul>
      </div>
    </div>
  </Transition>
  <!-- <div class="c-menu__close c-btn c-btn--close" @click="closeMenu"></div> -->
</div>
</template>

<script>

import Scrollbar from 'smooth-scrollbar';
import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
    data() {
        return {
            mvHeight: 0,
        }
    },
    computed: {
        isShowNav() {
            if  (this.$store.getters.showNav) this.resize();
            return this.$store.getters.showNav;
        },
        setMvHeight() {
            if (this.mvHeight > 0) {
                return `height: ${this.mvHeight}px;`;
            } else {
                return '';
            }
        },
    },
    watch: {
        isShowNav(newValue, oldValue) {
            // if (newValue) {
            //     // open
            //     this.pauseScroll();
            // } else {
            //     // close
            //     this.startScroll();
            // }
        },
    },
    mounted() {
      const contents = this.$el.querySelector('.c-menu__wrap');
      Scrollbar.init(contents, {
          continuousScrolling: false,
          // delegateTo: contents,
          alwaysShowTracks: false,
      });

    // Scrollbar.destroy(this.$el.querySelector('.c-menu__wrap'));

      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
        resize() {
            if (window.matchMedia('(max-width: 800px)').matches) {
                //SP
                this.mvHeight = innerHeight;
            } else {
                //PC
                this.mvHeight = 0;
            }
        },
        closeMenu() {
          this.$store.commit('showNav', false);
        },
        pauseScroll() {
            this.$el.addEventListener('wheel', this.disableWheel, {passive: false});
            this.$el.addEventListener('touchmove', this.disableWheel, {passive: false});
            this.$el.addEventListener('keyup', this.keyboardControl, {passive: true});
        },
        startScroll() {
            this.$el.removeEventListener('wheel', this.disableWheel);
            this.$el.removeEventListener('touchmove', this.disableWheel);
            this.$el.removeEventListener('keyup', this.keyboardControl);
        },
        disableWheel(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        keyboardControl(e) {
            // Escape
            if(e.keyCode === 27) {
                this.closeMenu();
            }
        },
        anchor(id) {
            this.closeMenu();
            gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
        }
    }
}

</script>